import './PrecheckControl.css';

import React, { FC } from 'react';

import { Button } from '@vmware-react/clarity';
import Clock from '../clock/Clock';
import {
  dateFormatters,
  formatDate,
  l10n
} from '../with-app-root/i18n/i18nUtil';

export type ControlType = 'Action' | 'Loader';

interface Props {
  type: ControlType;
  text: string;
  showDownloadReport: boolean;
  lastUpdateTimeMillis?: number;
  onClickValidate: () => void;
  onClickDownload: () => void;
}

const PrecheckControl: FC<Props> = props => {
  const {
    type,
    text,
    showDownloadReport,
    lastUpdateTimeMillis,
    onClickValidate,
    onClickDownload
  } = props;

  return (
    <div className="precheck-control">
      <>
        {type === 'Loader' ? (
          <span className="precheck-control-text">
            <span className="clock">
              <Clock />
            </span>
            <span role="alert">{text}</span>
          </span>
        ) : (
          <span className="precheck-control-action">
            <Button size="sm" class="primary" onClick={onClickValidate}>
              {text}
            </Button>
            {showDownloadReport && (
              <Button size="sm" class="primary" onClick={onClickDownload}>
                {l10n('components.preCheck.downloadReport')}
              </Button>
            )}
          </span>
        )}
      </>
      <>
        {lastUpdateTimeMillis && (
          <span>
            <>{l10n('components.preCheck.lastUpdatedOn')}</>
            <b className="precheck-last-updated">
              {formatDate(lastUpdateTimeMillis, dateFormatters.SHORT)}
            </b>
          </span>
        )}
      </>
    </div>
  );
};

export default PrecheckControl;
